import React, { lazy, Suspense, useContext } from 'react';
import classnames from 'classnames';
import SubmissionDetails from '../../../SubmissionDetails';
import ExtendedDetails from './ExtendedDetails';
import { BiDataHook } from '../../../biLogger/constants';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { useFlag } from '../../../redux/flags/hooks';
import { MobileContext } from '../../../Context';
import { useIsMounted } from '../../../utils/hooks/useIsMounted';
var LoadableMud = lazy(function () { return import('../../../OpenSea/Loadable'); });
import s from './Default.scss';
export var DefaultDetails = function (_a) {
    var deviation = _a.deviation, className = _a.className, contentClassName = _a.contentClassName;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isMobile = useContext(MobileContext);
    var mudkips = useFlag('mudkips');
    var isMounted = useIsMounted();
    return (React.createElement("div", { className: classnames(s['root'], className, contentClassName) },
        React.createElement("div", { className: s['title-block'], "data-hook": BiDataHook.DEVIATION_META },
            React.createElement(SubmissionDetails, { showTitle: true, deviation: deviation })),
        isMounted && !isMobile && mudkips && (React.createElement(Suspense, { fallback: null },
            React.createElement(LoadableMud, { deviation: deviation }))),
        isExtendedLoaded && React.createElement(ExtendedDetails, { deviation: deviation })));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
//# sourceMappingURL=Default.js.map